import { Routes, Route } from 'react-router-dom';
import Dashboard from '../pages/supervisor/Dashboard';
import Property from '../pages/supervisor/Property';
import Flag from '../pages/supervisor/flag';
import History from '../pages/supervisor/history';
import Resolve from '../pages/supervisor/resolved';
import Aiflag from '../pages/supervisor/aiflag';
import FlaggedByAI from '../pages/supervisor/FlaggedByAI';
import Inspectors from "../pages/supervisor/Inspectors";
import SupervisorBulkUpload from '../pages/supervisor/SupervisorBulkUpload';
import NotResolved from '../pages/supervisor/NotResolved';
const SupervisorRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/property" element={<Property />} />
      <Route path="/flaged" element={<Flag />} />
      <Route path="/resolved" element={<Resolve />} />
      <Route path="/history" element={<History />} />
      <Route path="/aiflag" element={<Aiflag />} />
      <Route path="/flagged-by-ai" element={<FlaggedByAI />} />
      <Route path="/inspectors" element={<Inspectors />} />
      <Route path="/my-uploads" element={<SupervisorBulkUpload />} />
      <Route path="/not-resolved" element={<NotResolved />} />
    </Routes>
  );
};

export default SupervisorRoutes;
